import Footer from "./Footer";
import '../../App.css';
import { Link, NavLink } from "react-router-dom";
import React, { useState, useEffect } from "react";
import { Edit, Trash2, Copy } from "lucide-react";
import Axios from 'axios';
import Cookies from 'js-cookie';

function Names(props) {

    const [loginMessage, setLoginMessage] = useState();
    const [loginStatus, setLoginStatus] = useState();

    const [items, setItems] = useState([]);

    Axios.defaults.withCredentials = true;

    //setLoginMessage('Please ' + <Link to="/Login" className="hover:text-gray-700">Login</Link> + ' to see your personalized content.');

    const handleCopy = (name) => {
        alert(`Copy item with ID: ${name}`);
        navigator.clipboard.writeText(name)
      };

      const handleDelete = (id) => {
        const confirmed = window.confirm("Are you sure you want to delete this item?");
        if (confirmed) {
          //setItems(items.filter((item) => item.id !== id));
          setItems(items.filter((item) => item.id !== id));
          Axios.post("https://mygamename.com/php/delete.php", {
            id: id,
          }).then((response) => {
                //setItems(items.filter((item) => item.id !== id));
          });
        }
      };

        useEffect(() => {
          const fetchProtected = async () => {
            try {
              const response = await Axios.get('https://mygamename.com/php/protected.php', { withCredentials: true });
              console.log(response.data.email);
              if (response.data.status === 'success') {
                //setEmail(response.data.email);
                props.setUEmail(response.data.email);
                setLoginStatus(true);
                Axios.post("https://mygamename.com/php/names.php", {
                    email: response.data.email,
                 }).then((response) => {
                    console.log(response);
                    if(Array.isArray(response.data)){
                      setItems(response.data);
                    }else{
                    }
                    });
              } else {
                //window.location.href = '/login';
              }
            } catch (error) {
              console.error(error);
              //window.location.href = '/login';
            }
          };
      
          fetchProtected();
        }, []);

        // Axios.get("https://localhost:4000/login")
        //     .then((response) => {
        //         if (response.data.loggedIn) {
        //           props.setUEmail(response.data.user[0].email);
        //           if(response.data.user[0].email !== null){
        //             Axios.post("https://localhost:4000/names", {
        //                   username: response.data.user[0].email,
        //                 }).then((response) => {
        //                     console.log(response);
        //                     if(Array.isArray(response.data)){
        //                         setItems(response.data);
        //                     }else{
        //                     }
        //             });
        //           }
        //         }
        //     })
        //     .catch((error) => console.error("Error checking session:", error));

  return (
    <div className="container mx-auto p-4">
      <div className="bg-white rounded-md p-4">
        {loginStatus ? <h1 className="text-xl font-bold mb-4">Names</h1> : <div className="mb-4 text-4xl leading-none tracking-tight text-gray-900 md:text-2xl lg:text-4xl dark:text-white text-center md:p-10 lg:p-20">Please <Link to='/login' className="text-indigo-600 mb-4 text-4xl leading-none tracking-tight text-gray-900 md:text-2xl lg:text-4xl dark:text-white">Login</Link> or <Link to='/login' className="text-indigo-600 mb-4 text-4xl leading-none tracking-tight text-gray-900 md:text-2xl lg:text-4xl dark:text-white">
        Create</Link> an account to view your content.</div>}
        <ul>
          {items.map((item) => (
            <li
              key={item.id}
              className="flex items-center justify-between border-b last:border-b-0"
            >
              {/* Name */}
              <div className="text-gray-700">{item.name}</div>

              {/* Buttons */}
              <div className="flex space-x-1">

                {/* Edit Button */}
                <div className="p-2">
                <button
                  onClick={() => handleCopy(item.name)}
                  className="bg-white border border-gray-300 p-2 rounded-md hover:shadow-md transition flex items-center justify-center"
                  aria-label={`Copy ${item.name}`}
                >
                  <Copy/>
                </button>
                </div>
                <div className="p-2">
                <Link to={`/names/${item.id}`}>
                <button
                  className="bg-white border border-gray-300 p-2 rounded-md hover:shadow-md transition flex items-center justify-center"
                  aria-label={`Copy ${item.name}`}
                >
                  <Edit/>
                </button>
                </Link>
                </div>
                {/* Delete Button */}
                <div className="p-2">
                <button
                  onClick={() => handleDelete(item.id)}
                  className="bg-white border border-gray-300 p-2 rounded-md hover:shadow-md transition flex items-center justify-center"
                  aria-label={`Delete ${item.name}`}
                >
                  <Trash2 />
                </button>
                </div>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Names;